export default function () {
  const externalLinks = document.querySelectorAll('a[target="_blank"]');

  externalLinks.forEach((link) => {
    link.innerHTML = `${link.innerHTML}<span class="visuallyhidden">Ce lien s'ouvrira dans une nouvelle fenêtre</span>`;
  });
}
